module.exports = require('./helpers/bundle-url').getBundleURL('lIDGV') + "logo.c51670a8.svg";